import { render, staticRenderFns } from "./courier-express-delivery-list.vue?vue&type=template&id=23b08eaf&"
import script from "./courier-express-delivery-list.vue?vue&type=script&lang=ts&"
export * from "./courier-express-delivery-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports